export const idToTemperatureStatus = (id: number) => {
	switch (id) {
	case 1:
		return {
			id, name: 'Ambient', temp_code: 'AMBIENT'
		};
	case 2:
		return {
			id, name: 'Chilled', temp_code: 'CHILLED'
		};
	case 3:
		return {
			id, name: 'Frozen', temp_code: 'FROZEN'
		};
	default:
		return {
			id: 0, name: 'Unknown', temp_code: 'UNKNOWN'
		};
	}
};
